import React, { useEffect, useState } from "react";
import { Carousel, Spinner } from "react-bootstrap";
import sliderimg from "../../Images/slider1.png";
import slider4 from "../../Images/slider4.png";
import prod3 from "../../Images/prod3.png";
import prod4 from "../../Images/prod4.png";
import { useDispatch, useSelector } from "react-redux";
import { getAllSlider } from "../../redux/actions/sliderActions";

const Slider = () => {
  const [index, setIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    setLoading(true);
    dispatch(getAllSlider());
    setLoading(false);
  }, []);

  const sliders = useSelector((state) =>
    state.sliderReducer.allSlider.filter((el) => el.status === true)
  );
  return (
    <Carousel activeIndex={index} onSelect={handleSelect}>
      {loading === false ? (
        sliders &&
        sliders.map((el) => {
          return (
            <Carousel.Item
              key={el._id}
              className="slider-background sliderr"
              style={{
                background: `${el.color}`,
                borderRight: 'unset'
              }}
              interval={2000}
            >
              <div className="d-flex flex-row justify-content-between align-items-center w-100 " style={{ height: '100%' }}>
                <div>
                  {el.images && el.images[0] && (
                    <a
                      href={el.link}
                      target="_blank"
                      rel="noreferrer"
                      style={{ textDecoration: "none" }}
                    >
                      <img
                        className="imgg"
                        src={el.images[0]}
                        alt="First slide"
                      />
                    </a>
                  )}
                </div>

                <div>
                  {el.images && el.images[1] && (
                    <a
                      href={el.link2}
                      target="_blank"
                      rel="noreferrer"
                      style={{ textDecoration: "none" }}
                    >
                      <img
                        className="imgg"
                        src={el.images[1]}
                        alt="First slide"
                      />
                    </a>
                  )}
                </div>

                {/* 
                 <div className="mx-3">
                    <h3 className="slider-title">{el.title}</h3>
                    <p className="slider-text">{el.description}</p>
              
                </div>
              */}
              </div>
            </Carousel.Item>
          );
        })
      ) : (
        <Spinner animation="border" variant="primary" />
      )}
    </Carousel>
  );
};

export default Slider;
